document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-flowik-filters]');
  var grid = document.querySelector('[data-flowik-collection-grid]');
  if (!bar || !grid) return;

  var activeTags = [];

  bar.querySelectorAll('[data-filter-tag]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var tag = chip.dataset.filterTag;

      if (tag === 'all') {
        bar.querySelectorAll('[data-filter-tag]').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        activeTags = [];
      } else {
        bar.querySelector('[data-filter-tag="all"]').classList.remove('is-active');
        chip.classList.toggle('is-active');
        activeTags = Array.prototype.slice.call(bar.querySelectorAll('[data-filter-tag].is-active'))
          .map(function (c) { return c.dataset.filterTag; })
          .filter(function (t) { return t !== 'all'; });
        if (!activeTags.length) bar.querySelector('[data-filter-tag="all"]').classList.add('is-active');
      }

      grid.querySelectorAll('[data-tags]').forEach(function (card) {
        var cardTags = card.dataset.tags.split(',');
        var visible = !activeTags.length || activeTags.every(function (orGroup) {
          var orTags = orGroup.split(',');
          return orTags.some(function (t) { return cardTags.indexOf(t) !== -1; });
        });
        card.style.display = visible ? '' : 'none';
      });
    });
  });
});
